






































import { PartyModel } from '@/libs/Api';
import { useObjectKey } from '@/libs/common/functions/use-object-key';
import { CrudAction, CrudReponse } from '@/libs/core/+state/models/crud-action';
import { CrudPartialUpdatePatch } from '@/libs/core/+state/models/crud-partial-update-patch';
import Page from '@/Page.vue';
import { Component, Prop, Ref, VModel, Watch } from 'vue-property-decorator';
import { partiesStore } from '../+state/store';

@Component({})
export default class EvaluationPlanDialog extends Page {

    @VModel() innerValue!: boolean;
    @Prop() party!: PartyModel;
    valid = true;
    saving = false;
    nextWorkTaskEvaluationDate: string | null = null;

    @Ref() form!: any; 

    mounted () {
        this.nextWorkTaskEvaluationDate = this.party.nextWorkTaskEvaluationDate ?? null;
    }

    close () {
        this.$emit("input", false);
    }

    save () {
        if (this.form.validate()) {
            this.saving = true;
            partiesStore.dispatch(CrudAction.PartialUpdate, { id: this.party.id, diff: [
                { op: 'replace', path: useObjectKey<PartyModel>('nextWorkTaskEvaluationDate'), value: this.nextWorkTaskEvaluationDate } as CrudPartialUpdatePatch
            ] });
            this.subscribe(partiesStore, CrudReponse.PartialUpdate).then(() => {
                this.saving = false;
                this.close();
            }).catch(() => {
                this.saving = false;
            });
        }
    }

}
